import React, { useEffect, useState } from "react";
import ongData from "../scripts/formOng";
import Select from "react-select";
import {
  FaBell,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarCheck,
  FaCalendarDay,
  FaClock,
  FaHourglass,
} from "react-icons/fa";
import { Pagination, PaginationItem } from "@mui/material";
import DatePicker from "react-flatpickr";
import {
  ArrowRightAlt,
  CalendarMonth,
  CalendarMonthOutlined,
  CheckCircle,
  Close,
  InboxOutlined,
} from "@mui/icons-material";

import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import "../assets_/rendez-vous.css";
import TableLoader from "./Loader/TableLoader";
import { ApiUrl } from "../config";

const MesRendezVous = () => {
  const [rendezVous, setRendezVous] = useState([]); // State to hold the fetched data
  const [filteredRendezVous, setFilteredRendezVous] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // State to hold the current page
  const [totalPages, setTotalPages] = useState(1); // State to hold the total pages
  const [selectedMode, setSelectedMode] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedRdvName, setSelectedRdvName] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);

  const [totalRdv, setTotalRdv] = useState(0);
  const [rdvTermine, setRdvTermine] = useState(0);
  const [rdvEnAttente, setRdvEnAttente] = useState(0);
  const [aujourdhui, setAujourdhui] = useState(0);

  const [filterIndex, setFilterIndex] = useState(0);

  const modes = [
    { value: "En ligne", label: "En ligne" },
    { value: "Physique", label: "Physique" },
  ];

  const status = [
    { value: "finish", label: "Terniné" },
    { value: "en_attente", label: "En attente" },
  ];

  const rdvName = [
    { value: "Assistant Sociale", label: "Assistant Sociale" },
    { value: "Medecin", label: "Médecin" },
    { value: "Psychologue", label: "Psychologue" },
  ];

  const token = Cookies.get("access_token");

  const fetchRendezVous = async (page) => {
    if (token) {
      const decodedToken = jwtDecode(token);
      const citoyen_id = decodedToken.citoyen_id;
      try {
        const response = await fetch(
          `${ApiUrl}getRdvByCitoyenId?citoyen_id=${citoyen_id}&page=${page}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        // console.log(data.last_page);

        setRendezVous(data.data);
        setCurrentPage(data.current_page);
        setTotalPages(data.last_page);

        // Filter and count the different categories
        const rdvToday = data.data.filter((rdv) => {
          const rdvDate = new Date(rdv.date);
          const today = new Date();
          return rdvDate.toDateString() === today.toDateString();
        });

        const totalAppointments = data.data.length;
        const finishedAppointments = data.data.filter(
          (rdv) => rdv.status === "finish"
        ).length;
        const waitingAppointments = data.data.filter(
          (rdv) => rdv.status === "en_attente"
        ).length;

        setTotalRdv(totalAppointments);
        setRdvTermine(finishedAppointments);
        setRdvEnAttente(waitingAppointments);
        setAujourdhui(rdvToday.length);
        //applyFilters();

        // console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const applyFilters = () => {
    let filterCount = 0;
    let filtered = [...rendezVous];
    setTimeout(() => {
      setLoading(false);
    }, 900);
    if (searchQuery) {
      const searchTerms = searchQuery.toLowerCase().split(" ");

      if (searchTerms.length === 2) {
        const [firstNamePart, lastNamePart] = searchTerms;

        filtered = filtered.filter(
          (rdv) =>
            (rdv.employe.nom.toLowerCase().includes(firstNamePart) &&
              rdv.employe.prenom.toLowerCase().includes(lastNamePart)) ||
            (rdv.employe.nom.toLowerCase().includes(lastNamePart) &&
              rdv.employe.prenom.toLowerCase().includes(firstNamePart))
        );
      } else {
        filtered = filtered.filter(
          (rdv) =>
            rdv.employe.nom.toLowerCase().includes(searchQuery.toLowerCase()) ||
            rdv.employe.prenom.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      filterCount++;
    }

    if (selectedMode) {
      console.log("Filtering by mode:", selectedMode.value);
      filtered = filtered.filter((rdv) => rdv.type_rdv === selectedMode.value);
      filterCount++;
    }

    if (selectedStatus) {
      console.log("Filtering by status:", selectedStatus.value);
      filtered = filtered.filter((rdv) => rdv.status === selectedStatus.value);
      filterCount++;
    }

    if (selectedRdvName) {
      console.log("Filtering by rdvName:", selectedRdvName.value);
      filtered = filtered.filter(
        (rdv) => rdv.rdv_name === selectedRdvName.value
      );
      filterCount++;
    }

    // if (selectedDate) {
    //   // Ensure selectedDate is a Date object
    //   const dateObj =
    //     selectedDate instanceof Date ? selectedDate : new Date(selectedDate);

    //   // Normalize the selected date to ignore time zone shifts
    //   const localDate = new Date(dateObj.setHours(0, 0, 0, 0)); // Set the time to midnight

    //   // Format the date to match your 'YYYY-MM-DD' format
    //   const formattedDate = localDate.toISOString().split("T")[0];

    //   console.log("Filtering by date:", formattedDate);

    //   // Now compare only the date part, ignoring time
    //   filtered = filtered.filter((rdv) => {
    //     const rdvDate = new Date(rdv.date); // Assuming rdv.date is in ISO format

    //     rdvDate.setHours(0, 0, 0, 0); // Set rdv time to midnight for comparison
    //     return rdvDate.toISOString().split("T")[0] === formattedDate;
    //   });
    //   filterCount++;
    // }

    if (selectedDate) {
      try {
        // Ensure selectedDate is a Date object
        const dateObj =
          selectedDate instanceof Date ? selectedDate : new Date(selectedDate);

        if (!isNaN(dateObj)) {
          // Normalize the date to ignore time
          const localDate = new Date(dateObj.setHours(0, 0, 0, 0));
          const formattedDate = localDate.toISOString().split("T")[0];

          console.log("Filtering by date:", formattedDate);

          filtered = filtered.filter((rdv) => {
            const rdvDateObj = new Date(rdv.date);
            if (isNaN(rdvDateObj)) return false; // skip invalid dates
            rdvDateObj.setHours(0, 0, 0, 0);
            return rdvDateObj.toISOString().split("T")[0] === formattedDate;
          });

          filterCount++;
        }
      } catch (err) {
        console.warn("Invalid selected date:", selectedDate, err);
      }
    }

    console.log("Filtered results:", filtered);
    setFilteredRendezVous(filtered);
    setFilterIndex(filterCount);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    applyFilters();
  };

  const resetFilters = () => {
    setSelectedMode(null);
    setSelectedStatus(null);
    setSelectedRdvName(null);
    setSelectedDate(null);
    setSearchQuery(""); // Reset search query
    setFilterIndex(0); // Reset the filter counter when filters are cleared

    // Optionally, reset filteredRendezVous to the original rendezVous
    setFilteredRendezVous(rendezVous);
  };

  useEffect(() => {
    fetchRendezVous(currentPage);
  }, [currentPage]);

  // Reapply filters whenever a filter value changes
  useEffect(() => {
    applyFilters();
  }, [
    selectedMode,
    selectedStatus,
    selectedRdvName,
    selectedDate,
    searchQuery,
    rendezVous,
  ]);

  // Reapply filters whenever a filter value changes

  const formatTime = (time) => {
    const date = new Date("1970-01-01T" + time); // Add a fixed date to parse time
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const calculateDuration = (startTime, endTime) => {
    const start = new Date("1970-01-01T" + startTime); // Parse to Date
    const end = new Date("1970-01-01T" + endTime); // Parse to Date

    // Calculate the difference in milliseconds
    const durationInMs = end - start;

    // Convert milliseconds to hours, minutes, and seconds
    const durationInSeconds = durationInMs / 1000;
    const durationInMinutes = durationInMs / (1000 * 60);
    const durationInHours = durationInMs / (1000 * 60 * 60);

    if (durationInHours >= 1) {
      // Return hours and minutes
      const hours = Math.floor(durationInHours);
      const minutes = Math.floor((durationInHours - hours) * 60);
      return `${hours}h ${minutes}min`;
    } else if (durationInMinutes >= 1) {
      // Return minutes and seconds
      const minutes = Math.floor(durationInMinutes);
      return `${minutes}min`;
    } else {
      // Return seconds
      const seconds = Math.floor(durationInSeconds);
      return `${seconds}s`;
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const renderRdvName = (rdv_name) => {
    switch (rdv_name) {
      case "Medecin":
        return "Médecin";
      case "Psychologue":
        return "Psychologue";
      case "Psy":
        return "Psychologue";
      case "Assistant Sociale":
        return "Assistant Sociale";
      default:
        return rdv_name; // If the name is not one of the above, display it as it is.
    }
  };
  const renderStatus = (status) => {
    switch (status) {
      case "finish":
        return { text: "Términé", className: "bg-success" };
      case "en_attente":
        return { text: "En attente", className: "bg-warning" };
      default:
        return { text: status, className: "" }; // If no match, return original status and no class
    }
  };

  const getBadgeClass = (type) => {
    if (type === "Physique") {
      return "bg-primary"; // For 'Physique', return 'bg-primary'
    } else if (type === "En ligne") {
      return "bg-secondary"; // For 'En ligne', return 'bg-secondary'
    }
    return ""; // Default if no match (you can adjust if needed)
  };

  return (
    <div
      className="  z-index-2 border-radius-5 p-xl-3 p-3"
      style={{ height: "90%" }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb breadcrumb-no-gutter">
          <li className="breadcrumb-item">
            <a className="breadcrumb-link" href="javascript:;">
              Page d'acceuil
            </a>
          </li>
          <li
            className="breadcrumb-item active"
            style={{ color: "rgb(255, 77, 7)" }}
            aria-current="page"
          >
            Rendez-vous
          </li>
        </ol>
      </nav>

      <div className="row">
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <span className="text-blue text-uppercase fs-12 fw-bold">
                    AUJOURD'HUI
                  </span>
                  <div className="d-flex">
                    <h3 className="mb-0 text-blue">{aujourdhui}</h3>
                    <div className="d-flex mt-1 ms-3">
                      <p className="text-danger">
                        <span>-2.8%</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-arrow-top icon-sm"
                          appfeathericon=""
                        >
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <polyline points="19 12 12 19 5 12"></polyline>
                        </svg>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-md-3 mt-xl-0 txt-light avatar avatar-icon avatar-danger">
                  {/* <i className="feather icon-bell avatar-icon icon-xl"></i> */}
                  <CalendarMonth className="avatar-icon icon-xl" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <span className="text-blue text-uppercase fs-12 fw-bold">
                    Total Rendez-vous
                  </span>
                  <div className="d-flex">
                    <h3 className="mb-0 text-blue">{totalRdv}</h3>
                    <div className="d-flex mt-1 ms-3">
                      <p className="text-success">
                        <span>+2.8%</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-arrow-up icon-sm mb-1"
                          appfeathericon=""
                        >
                          <line x1="12" y1="19" x2="12" y2="5"></line>
                          <polyline points="5 12 12 5 19 12"></polyline>
                        </svg>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  style={{ backgroundColor: "#4169E1" }}
                  className="mt-md-3 mt-xl-0 txt-light avatar avatar-icon avatar-blue"
                >
                  {/* <i className="feather icon-bell avatar-icon icon-xl"></i> */}
                  <CalendarMonth className="avatar-icon icon-xl" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <span className="text-blue text-uppercase fs-12 fw-bold">
                    Rendez-vous Términé
                  </span>
                  <div className="d-flex">
                    <h3 className="mb-0 text-blue">{rdvTermine}</h3>
                    <div className="d-flex mt-1 ms-3">
                      <p className="text-success">
                        <span>+2.8%</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-arrow-up icon-sm mb-1"
                          appfeathericon=""
                        >
                          <line x1="12" y1="19" x2="12" y2="5"></line>
                          <polyline points="5 12 12 5 19 12"></polyline>
                        </svg>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-md-3 mt-xl-0 txt-light avatar avatar-icon avatar-success">
                  {/* <i className="mdi mdi-face-woman avatar-icon icon-xl"></i> */}
                  <CheckCircle className="avatar-icon icon-xl" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <span className="text-blue text-uppercase fs-12 fw-bold">
                    Rendez-vous en attente
                  </span>
                  <div className="d-flex">
                    <h3 className="mb-0 text-blue">{rdvEnAttente}</h3>
                    <div className="d-flex mt-1 ms-3">
                      <p className="text-success">
                        <span>+2.8%</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-arrow-up icon-sm mb-1"
                          appfeathericon=""
                        >
                          <line x1="12" y1="19" x2="12" y2="5"></line>
                          <polyline points="5 12 12 5 19 12"></polyline>
                        </svg>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-md-3 mt-xl-0 txt-light avatar avatar-icon avatar-warning">
                  {/* <i className="mdi mdi-face-woman avatar-icon icon-xl"></i> */}
                  <FaClock className="avatar-icon icon-xl" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col card">
          <div className="d-flex card-header title  justify-content-between ">
            <h5 className="mt-1">
              <CalendarMonthOutlined className="mb-1" /> Liste des Rendez-vous
            </h5>
            <a
              onClick={resetFilters}
              className="text-secondary align-self-center mt-1 cursor-pointer text-decoration-underline"
              style={{ fontSize: "15px" }}
            >
              <Close
                style={{ width: "20px", height: "20px" }}
                className="align-self-center"
              />{" "}
              Supprimer les Filters({filterIndex})
            </a>
          </div>

          <div className="card-body">
            <div className="pt-3">
              <div className="row">
                <div className="col-3">
                  <div className="single-input-inner style-border me-2">
                    <input
                      style={{
                        width: "100%",
                        height: "39px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                      type="text"
                      placeholder="Rechercher"
                      className="my-custom-text"
                      value={searchQuery} // Bind input value to searchQuery state
                      onChange={handleSearchChange} // Update search query on input change
                    />
                  </div>
                </div>
                <div className="col-3">
                  <DatePicker
                    id="date-picker"
                    value={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    options={{
                      dateFormat: "Y-m-d",
                    }}
                    render={({ defaultValue, value, ...props }, ref) => (
                      <div className="date-picker-input-wrapper">
                        <FaCalendarAlt className="calendar-icon" />
                        <input
                          {...props}
                          ref={ref}
                          placeholder="Sélectionnez une date..."
                          className="date-picker-input"
                          readOnly
                          value={value || ""}
                        />
                      </div>
                    )}
                  />
                </div>

                <div className="col-2">
                  <Select
                    className="me-2"
                    value={selectedMode}
                    onChange={setSelectedMode}
                    options={modes}
                    placeholder="Mode"
                    isSearchable={true}
                  />
                </div>
                <div className="col-2">
                  <Select
                    className="me-2"
                    value={selectedStatus}
                    onChange={setSelectedStatus}
                    options={status}
                    placeholder="Statut"
                    isSearchable={true}
                  />
                </div>

                <div className="col-2">
                  <Select
                    className="me-2"
                    value={selectedRdvName}
                    onChange={setSelectedRdvName}
                    options={rdvName}
                    placeholder="Intervenant"
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>
            {loading ? (
              <TableLoader rows={5} columns={9} />
            ) : (
              <table className="table table-hover mt-4">
                <thead>
                  <tr>
                    <th scope="col">#ID</th>
                    <th scope="col">Intervenant</th>
                    <th scope="col">Séance</th>
                    <th scope="col"> Date</th>
                    <th scope="col"> Heures</th>
                    <th scope="col">Durée</th>
                    <th scope="col">Mode</th>

                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRendezVous && filteredRendezVous.length > 0 ? (
                    filteredRendezVous
                      .filter(
                        (appointment) =>
                          appointment.rdv_name !== "Gendarme" &&
                          appointment.rdv_name !== "Procureur"
                      )
                      .map((appointment, index) => (
                        <tr key={appointment?.id}>
                          <td>#{index + 1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <p className="fw-bold mb-1">
                                  {appointment?.employe?.nom}{" "}
                                  {appointment?.employe?.prenom}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="fw-normal mb-1">
                              {renderRdvName(appointment?.rdv_name)}
                            </p>
                          </td>
                          <td>{appointment?.date || "-"}</td>
                          <td>
                            {appointment?.startTime && appointment?.endTime
                              ? `${formatTime(
                                  appointment.startTime
                                )} - ${formatTime(appointment.endTime)}`
                              : "Heure non définie"}
                          </td>
                          <td>
                            <p>
                              {appointment?.startTime && appointment?.endTime
                                ? calculateDuration(
                                    appointment.startTime,
                                    appointment.endTime
                                  )
                                : "Durée non disponible"}
                            </p>
                          </td>
                          <td>
                            <span
                              className={`badge ${getBadgeClass(
                                appointment?.type_rdv
                              )}`}
                            >
                              {appointment?.type_rdv}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                renderStatus(appointment?.status).className
                              }`}
                            >
                              {renderStatus(appointment?.status).text}
                            </span>
                          </td>
                          <td>
                            <div className="custom-btn custom-btn-warning-outline">
                              {" "}
                              Détails
                              <ArrowRightAlt style={{ fontSize: "18px" }} />
                            </div>
                          </td>
                          <td>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colspan="100%">
                        <div className="text-center p-5">
                          <div className="mt-md-3 mt-xl-0 text-muted">
                            {/* <i className="feather icon-inbox display-6"></i> */}
                            <InboxOutlined
                              style={{
                                fontSize: "50px",
                                color: "rgb(167 166 166)",
                              }}
                            />
                          </div>
                          <p
                            className="empty-title"
                            style={{
                              marginTop: "8px",
                              fontSize: "16px",
                              color: "rgb(112 110 110)",
                            }}
                          >
                            Aucun résultat trouvé
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  {rendezVous && rendezVous.length > 0 ? (
                    <tr>
                      <td colSpan="9">
                        <div className="d-flex justify-content-between align-items-center p-1">
                          <div>
                            Showing {rendezVous.length} of {totalPages} entries
                          </div>
                          <div>
                            <Pagination
                              count={totalPages}
                              page={currentPage}
                              onChange={handlePageChange}
                              color="primary"
                              shape="rounded"
                              sx={{
                                "& .MuiPaginationItem-root": {
                                  borderRadius: "50px", // Rounded style for pagination items
                                  backgroundColor: "#f1f1f1", // Light gray background for unselected pages
                                  "&.Mui-selected": {
                                    backgroundColor: "rgb(255, 77, 7)", // Bootstrap blue color when selected
                                    color: "white", // White text when selected
                                  },
                                  "&:hover": {
                                    backgroundColor: "#e0e0e0", // Hover color for pagination items
                                  },
                                },
                                marginTop: "20px",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan="9"></td>
                    </tr>
                  )}
                </tfoot>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MesRendezVous;
